export enum ChangeType {
  Added = 'added',
  Modified = 'modified',
  Deleted = 'deleted',
}

export class FileChange {
  public Path!: string;
  public Change!: ChangeType;
  public Size!: number;
  public ModificationTime!: string;

  public IsDirectory!: boolean;
  public IsTemporary!: boolean;
  public IsSymlink!: boolean;
  public IsDevice!: boolean;
  public IsNamedPipe!: boolean;
  public IsSocket!: boolean;
  public IsIrregular!: boolean;
}
